import Question from './question';

export default Question;
